import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from './store/store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import(/* webpackChunkName: "about" */ './views/About.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/noticiasadmin',
            name: 'noticiasadmin',
            component: () => import('./views/NoticiasAdmin.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/pediatria',
            name: 'pediatria',
            component: () => import('./views/Pediatria.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/cerveceria',
            name: 'cerveceria',
            component: () => import('./views/Cerveceria.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/gourmet',
            name: 'gourmet',
            component: () => import('./views/Gourmet.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/privacidad',
            name: 'privacidad',
            component: () => import('./views/PoliticasPrivacidad.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/sucursales',
            name: 'sucursales',
            component: () => import('./views/Sucursales.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/centrosconsumo',
            name: 'centrosconsumo',
            component: () => import('./views/CentrosDeConsumo.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/contacto',
            name: 'contacto',
            component: () => import('./views/Contacto.vue'),
            meta: {
                authRequired: true
            }
        },
        { path: '/redirect-me', redirect: { name: 'home' } },
        { path: '*', redirect: '/' }
    ]
});

export default router;
